// ============================================================================
// UKRAINIAN TRANSLATIONS - UI
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'uk',
    languageName: 'Українська',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST Хроніки\nЛюбові",
    subtitle: "Інтерактивне Вивчення Писань",
    tagline: "Йти до божественного світла",
    menu: "Меню",
    retry: "Повторити"
  },
  
  buttons: {
    play: "ГРАТИ",
    back: "Назад",
    continue: "Продовжити",
    restart: "Почати заново",
    close: "Закрити",
    nextLevel: "Наступний Рівень",
    selectLevel: "Вибір Рівня",
    retry: "Повторити",
    mainMenu: "Головне Меню",
    start: "Почати",
    cancel: "Скасувати",
    confirm: "Підтвердити",
    save: "Зберегти",
    load: "Завантажити",
    yesRestart: "Так, почати заново",
    noContinue: "Ні, продовжити",
    tryAgain: "Спробувати знову",
    backToMenu: "Повернутися до меню"
  },
  
  labels: {
    score: "Рахунок",
    stars: "Зірки",
    wisdom: "Мудрість",
    revelation: "Одкровення",
    lives: "Життя",
    combo: "Комбо",
    level: "РІВЕНЬ",
    easy: "ЛЕГКО",
    medium: "СЕРЕДНЬО",
    hard: "ВАЖКО",
    correct: "Правильно!",
    gameOver: "Провалено",
    victory: "Перемога!",
    completed: "Завершено",
    rank: "Духовний Ранг",
    points: "Очки Мудрості",
    unlockedLevels: "рівнів розблоковано",
    questionOfKnowledge: "Питання знань",
    hintOfWisdom: "Підказка мудрості",
    knowledgeMastered: "Знання опановано!",
    knowledgeAcquired: "Знання здобуто!",
    testFailed: "Провалено",
    wisdomBonus: "Бонус",
    xpGained: "XP",
    newRank: "Новий ранг",
    nextGrade: "Наступний ранг",
    maxLevelReached: "Досягнуто максимального рівня!",
    wrongAnswer: "Неправильна відповідь!"
  },
  
  menu: {
    playButton: "ГРАТИ",
    info: "Інфо",
    treasures: "Скарби",
    john: "Іоанн",
    reset: "Скинути",
    resetConfirm: "Почати пригоду заново?",
    resetWarning: "Ви впевнені, що хочете стерти весь свій прогрес?",
    resetLose: "Ви втратите:",
    wisdomPoints: "Очків Мудрості",
    starsCollected: "зібраних зірок",
    levelsUnlocked: "розблокованих рівнів",
    spiritualRank: "Духовний Ранг",
    yesRestart: "Так, почати заново",
    noContinue: "Ні, продовжити",
    newAdventure: "Нова Пригода",
    readyToStart: "Готові почати?",
    startJourney: "Почніть свою подорож у знання Писань!",
    audioControls: "Керування аудіо",
    mute: "Вимкнути звук",
    unmute: "Увімкнути звук",
    close: "Закрити",
    language: "Мова",
    restartGame: "Перезапустити гру"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "Інтерактивна біблійна пригода",
    anonymousMode: "Грати Анонімно",
    anonymousDesc: "Виберіть псевдонім",
    emailMode: "Вхід через Email",
    emailDesc: "Збереження на кількох пристроях",
    pseudo: "Псевдонім",
    pseudoPlaceholder: "Ваш псевдонім...",
    email: "Email Адреса",
    emailPlaceholder: "ваш@email.com",
    startPlaying: "Почати гру",
    sendLink: "Надіслати посилання",
    sending: "Надсилання...",
    connecting: "Підключення...",
    back: "Назад",
    localSave: "Ваш прогрес буде збережено локально",
    cloudSync: "Пароль не потрібен • Синхронізація в хмарі",
    magicLink: "Отримайте магічне посилання через email",
    checkEmail: "✉️ Перевірте свою пошту! Посилання для входу надіслано.",
    checkSpam: "Перевірте також папку спам",
    waitingConnection: "Очікування підключення...",
    errorSend: "Помилка надсилання посилання",
    rateLimited: "⏳ Будь ласка, зачекайте 15 секунд перед повторним надсиланням листа",
    importSession: "🔄 Імпортувати сесію з продакшену",
    errorConnection: "Помилка підключення",
    enterPseudo: "Будь ласка, введіть псевдонім",
    enterEmail: "Будь ласка, введіть дійсний email",
    // Tooltips
    never: "Ніколи",
    save: "Зберегти гру",
    lastSave: "останнє",
    refresh: "Перезавантажити прогрес",
    logout: "Вийти",
    connectToCloud: "Підключитися для збереження онлайн",
    editPseudo: "Змінити ім'я",
    confirm: "Підтвердити",
    cancel: "Скасувати",
    close: "Закрити",
    passwordMode: "Простий Вхід",
    passwordDesc: "Email + пароль",
    password: "Пароль",
    passwordPlaceholder: "Мінімум 6 символів",
    passwordMinLength: "Мінімум 6 символів",
    playWithoutAccount: "Грати без облікового запису",
    forgotPassword: "Забули пароль?",
    resetPasswordTitle: "Скинути Пароль",
    resetPasswordSubtitle: "Введіть email для отримання посилання скидання",
    sendResetLink: "Надіслати Посилання",
    resetEmailSent: "📧 Лист для скидання надіслано! Перевірте пошту.",
    errorReset: "Помилка надсилання листа",
    backToSignin: "Назад до входу",
    newPassword: "Новий Пароль",
    enterNewPassword: "Оберіть новий безпечний пароль",
    confirmPassword: "Підтвердіть Пароль",
    updatePassword: "Оновити Пароль",
    passwordsDontMatch: "Паролі не збігаються",
    passwordUpdateSuccess: "✅ Пароль успішно оновлено!",
    errorUpdatePassword: "Помилка оновлення пароля",
    resetLinkExpired: "Посилання скидання минуло або недійсне",
    forgotPassword: "Забули пароль?",
    signup: "Реєстрація",
    signin: "Увійти",
    createAccount: "Створити Обліковий Запис",
    signupInfo: "Заповніть форму нижче",
    passwordInfo: "Швидкий доступ з паролем",
    signupButton: "Створити Мій Обліковий Запис",
    signinButton: "Увійти",
    passwordTooShort: "Пароль повинен містити не менше 6 символів",
    emailAlreadyExists: "Цей email вже використовується",
    emailExistsHint: "✉️ Цей email вже зареєстровано. Спробуйте увійти! (Можливо, створено з іншої гри?)",
    switchToSignin: "🔑 Перейдіть у режим входу з вашим існуючим email",
    invalidCredentials: "Невірний email або пароль",
    signupSuccess: "📧 Акаунт створено! Перевірте email для підтвердження реєстрації.",
    emailConfirmationRequired: "Перевірте вхідні повідомлення для активації акаунту",
    checkSpamFolder: "Не забудьте перевірити папку спам",
    connectionSuccess: "✅ Успішний вхід!",
    errorSignup: "Помилка при реєстрації"},
  
  install: {
    title: "Встановити додаток",
    subtitle: "Швидкий доступ та офлайн",
    feature1: "Миттєвий запуск з головного екрану",
    feature2: "Працює офлайн після встановлення",
    feature3: "Досвід нативного додатку",
    feature4: "Не потрібне завантаження з магазину",
    install: "Встановити",
    dismiss: "Пізніше",
    info: "Ви можете видалити додаток у будь-який час"
  },
  
  ranks: {
    seeker: "Шукач",
    believer: "Пробуджений",
    disciple: "Учень",
    servant: "Служитель",
    witness: "Свідок",
    guardian: "Сторож",
    wise: "Мудрець",
    prophet: "Пророк",
    apostle: "Апостол",
    seekerDesc: "Початок духовної подорожі",
    believerDesc: "Пробуджена духовна свідомість",
    discipleDesc: "Вивчення вчень",
    servantDesc: "Служіння та відданість",
    witnessDesc: "Ділення вірою",
    guardianDesc: "Захист істини",
    wiseDesc: "Мудрість та знання",
    prophetDesc: "Духовне бачення",
    apostleDesc: "Духовний майстер"
  },

  spiritualJourney: {
    beginning: "Початок духовної подорожі",
    progress: "Духовний прогрес",
    grade: "Ступінь",
    xp: "XP",
    level: "Рівень",
    nextGrade: "Наступний ступінь",
    still: "Ще",
    maxLevelReached: "Досягнуто Максимальний Рівень!",
    masteredAllTeachings: "Ви опанували всі вчення",
    progression: "Прогресія"
  },
  
  treasures: {
    title: "💎 Скарби Біблії",
    verse: "Вірш дня",
    fact: "Чи знаєте ви?",
    treasure: "Прихований скарб",
    question: "Цікаве питання",
    context: "Контекст",
    strongReference: "Біблійне посилання для поглибленого вивчення",
    verseOfDay: "✨ Вірш дня",
    didYouKnow: "🌟 Чи знаєте ви?",
    hiddenTreasure: "📜 Прихований скарб",
    funnyQuestion: "🤔 Цікаве питання",
    emmanuelMemo: "Нотатка Еммануїла",
    emmanuelMessage: "Ви досягли вершини гори, і знання здобуто. Але непохитна віра вимагає життєвого досвіду, милосердя та справжньої любові Ісуса. Різні випробування життя перевірять ваш шлях, справжній шлях, який ми обираємо, наше серце. Ми залишаємось недосконалими, наші бажання численні, і любов до наживи або до нашого особистого комфорту занадто часто стає нашим егоїстичним пріоритетом. Просіть у Бога мудрості, його любові, його сили, і смиренно визнавайте свої слабкості, бо нічого не може бути приховано від Нього... Нічого. Немає потреби подорожувати в приватному режимі, використовувати VPN або навіть видаляти історію. Постіть, як Даниїл: позбавте себе на мить того, що ви любите найбільше, у спокої та мудрості. Це дозволить вам краще чути Бога, мати розташування серця, готового до глибоких - і часто болісних - перетворень. Тоді сни та видіння стануть яснішими, як у Йосипа. Але остерігайтеся гордості: не піддавайтеся 'Я завжди правий' або 'Я знаю краще'. Бо одкровення Бога - це надзвичайна благодать. Не ставайте вчителем Закону, здатним знову розіпнути Ісуса сьогодні, Того, Хто просто просить любити ближнього... і надати їм ту саму свободу, яку ви отримуєте. Мати віру означає вступити у вільні відносини та подорож серця. Це зробить вас могутніми героями, здатними на неможливе. Бо досвід надприродного, присутність Бога, його підтвердження або благословення зроблять вас справді непохитними.",
    jesusIsNot: "❌ Важливе уточнення",
    clarification: "Важливе уточнення",
    bibleOffline: "Читати Біблію Офлайн",
    bibleStudy: "Біблійне вивчення",
    version: "Версія",
    openReader: "Відкрити читалку",
    features: "Функції"
  },
  
  messages: {
    chooseCard: "⚡ Виберіть вашу карту сили",
    cardHelp: "Вона супроводжуватиме вас у 3 питаннях цього рівня",
    chooseAnswer: "📖 Виберіть вашу відповідь:",
    wrongAnswer: "❌ Неправильна відповідь! У вас залишилося {lives} життів. Спробуйте знову!",
    levelCompleted: "Рівень {level} Завершено",
    questionsProgress: "Питання {current} з 3",
    starsCollected: "Зібрано зірок: {current}/{total}",
    pointsEarned: "+{points} Очків Мудрості",
    defeatedQuote: "Все можу в Тому, Хто мене зміцнює",
    chapter: "Розділ",
    chapterStars: "зірки розділу",
    totalGlobal: "Загальний підсумок",
    backToMenu: "Повернутися до Меню",
    perfect: "🃏 Ідеально",
    good: "✅ Добре",
    start: "✅ Початок",
    secretLevel: "🔓 СЕКРЕТНИЙ РІВЕНЬ РОЗБЛОКОВАНО!",
    secretChapter: "🎁 Секретний Розділ",
    returnToLevels: "Повернутися",
    next: "Далі",
    retry: "Повторити",
    menu: "Меню"
  },
  
  quotes: {
    wisdom: "Початок мудрості — страх Господній",
    faith: "Все можу в Тому, Хто мене зміцнює",
    hope: "Господь — Пастир мій, нічого мені не бракує",
    love: "Бо так Бог полюбив світ...",
    perseverance: "Віра вимагає наполегливості",
    defeat: "Невдача запрошує рости в пізнанні"
  },

  cards: {
    faith: "ВІРА",
    courage: "МУЖНІСТЬ",
    wisdom: "МУДРІСТЬ",
    faithKnowledge: "+50% балів",
    courageKnowledge: "Другий шанс",
    wisdomKnowledge: "Підказка + бонус",
    faithDesc: "Максимум отриманих балів мудрості",
    courageDesc: "Звичайні бали, але другий шанс",
    wisdomDesc: "Розкрита підказка і +25% балів",
    chooseCard: "✨ Виберіть дар знання",
    cardEffects: "✨ Ефекти дарів знання:",
    faithEffect: "+50% балів мудрості - Максимальна нагорода",
    courageEffect: "Звичайні бали, але другий шанс при помилці",
    wisdomEffect: "+25% балів + розкрита підказка для кожного питання",
    chooseWisely: "Вибирайте мудро, ваш вибір супроводжуватиме вас протягом усього рівня"
  },

  challenge: {
    loading: "Завантаження рівня...",
    peace: "🕊️ Нехай мир перебуває у вашому домі",
    questionsAwaiting: "🎯 На вас чекають 3 питання знання",
    starsQuote: "Кожна зірка - це крок до божественного світла"
  },

  chapters: {
    "1": "Буття",
    "2": "Вихід",
    "3": "Ісус Христос",
    "4": "Розп'яття/Воскресіння",
    "5": "Рання Церква",
    "6": "Місії Павла",
    "7": "Листи/Одкровення",
    "8": "Бонусний рівень"
  },

  bible: {
    readerTitle: "📖 Читалка Біблії",
    loading: "Завантаження Писань...",
    menu: "Меню",
    strong: "Strong",
    strongReferences: "Посилання Strong",
    verses: "вірші",
    previous: "Назад",
    next: "Далі",
    strongDefinition: "Посилання Strong",
    word: "Оригінальне слово",
    transliteration: "Транслітерація",
    pronunciation: "Вимова",
    meaning: "Значення",
    definition: "Повне визначення",
    usage: "Біблійне використання",
    etymology: "Етимологія",
    close: "Закрити",
    moreReferences: "та {{count}} інших посилань",
    copyright: "📖 Ukrainian Bible 1962 - Суспільне надбання • Номери Strong включені"
  },

  philosophy: {
    title: "Філософський вимір",
    loveOntology: "Любов як онтологічний принцип",
    loveDescription: "Ісус перетворює любов на метафізичний фундамент: любов до Бога і ближнього стає самою структурою справжнього буття. Любов виходить за межі моралі, стаючи способом існування.",
    newCommandment: "Нова Заповідь",
    jesusEmphasizes: "Коли Ісус дає нову заповідь, Він наголошує на дієслові любити",
    loveGod: "Люби Бога всім серцем",
    loveNeighbor: "Люби ближнього свого, як самого себе",
    lovePriority: "Любов стає пріоритетом"
  },

  footer: {
    version: "Версія 1.0 • 2024",
    dedication: "Розроблено на славу Божу"
  },

  endCredits: {
    lines: [
      { text: "Ти досяг вершини гори", delay: 2000 },
      { text: "Ти багато чому навчився", delay: 2000 },
      { text: "Твоя віра росте щодня", delay: 2000 },
      { text: "Ти переживаєш прекрасне з Богом", delay: 2000 },
      { text: "Труднощі допомагають тобі рости", delay: 2000 },
      { text: "Вони показують, що важливо", delay: 2000 },
      { text: "Будь смиренним, як мала дитина", delay: 2000 },
      { text: "Бог любить твоє просте серце", delay: 2000 },
      { text: "У тиші ти чуєш Бога", delay: 2000 },
      { text: "Піст звільняє твій дух", delay: 2000 },
      { text: "Молися, і Бог поведе тебе", delay: 2000 },
      { text: "Гордість приховує істину", delay: 2000 },
      { text: "Благодать Божа велична", delay: 2000 },
      { text: "Вона виходить із серця Божого", delay: 2000 },
      { text: "Справжня віра робить тебе вільним", delay: 2000 },
      { text: "Вона з'єднує тебе з Богом навіки", delay: 2000 },
      { text: "Любов може все змінити", delay: 2000 },
      { text: "Вона може творити чудеса", delay: 2000 },
      { text: "Повтори за мною", delay: 2000 },
      { text: "Ісусе, я віддаю Тобі моє серце", delay: 3000 },
      { text: "Ти мій цар, мій спаситель", delay: 3000 },
      { text: "Прийди, перетвори моє життя", delay: 3000 },
      { text: "Шлях продовжується зараз", delay: 2000 },
      { text: "Поділися цим прекрасним світлом", delay: 2000 },
      { text: "До життя, що ніколи не закінчується", delay: 2000 },
      { text: "Зберігай любов у своєму серці", delay: 3000 },
      { text: "Як дорогоцінний скарб", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "ВІТАЄМО!",
      proud: "МИ ПИШАЄМОСЯ ТОБОЮ",
      courage: "ВІДВАЖНИЙ ВОЇН",
      peace: "НОСІЙ МИРУ",
      child: "ДИТЯ БОЖЕ",
      blessing: "НЕХАЙ БОГ БЛАГОСЛОВИТЬ ТЕБЕ",
      continue: "Продовжити"
    }
  },

  mountain: {
    spiritualAscension: "Духовне сходження",
    levelProgress: "Рівень {{level}} • {{stars}} зірок отримано",
    combo: "Комбо",
    perfectMessage: "\"Бо думки Мої - не ваші думки\" - Агнець піднімається до досконалої мудрості",
    goodMessage: "\"Шукайте і знайдете\" - Сходження до істини продовжується",
    startMessage: "\"Віра, навіть маленька як гірчичне зерно\" - Перший крок до світла",
    skipAnimation: "Пропустити анімацію",
    chapter: "Розділ",
    chapterProgress: "Розділ {{current}}/{{total}}",
    secret: "Секрет",
    waypoints: {
      start: "Початок",
      firstSlope: "Перший схил",
      lastSlope: "Останній схил"
    },
    status: {
      defeat: "Поразка",
      inProgress: "В процесі",
      victory: "Перемога"
    }
  },

  validation: {
    pseudoTooShort: "Ім'я користувача повинно містити щонайменше 2 символи",
    enterPseudo: "Будь ласка, введіть ім'я користувача"
  },

  pseudoSetup: {
    title: "Виберіть ім'я користувача",
    confirm: "Підтвердити Ім'я"
  },

  navigation: {
    back: "Назад"
  },

  console: {
    starsUnlocked: "зірки досягнуті! Розблокування розділу",
    defeatAnimation: "Поразка... І.Х. спускається"
  },

  errors: {
    progressionError: "Помилка прогресу",
    invalidProgressionData: "Недійсні дані прогресу:"
  },

  levels: {
    chaptersAndBonus: "8 розділів + бонусний рівень",
    bonusUnlocked: "🏆 БОНУСНИЙ РІВЕНЬ РОЗБЛОКОВАНО! Ви досягли духовної досконалості!",
    starsToDiscover: "273 {stars} для відкриття",
    starsPerLevel: "3 {stars} за рівень"
  },

  architecture: {
    title: "🔧 Технічна архітектура",
    react: {
      name: "React",
      description: "Сучасний інтерфейс"
    },
    modules: {
      name: "Модулі",
      description: "Динамічне завантаження"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Локальне сховище"
    },
    tailwind: {
      name: "Tailwind",
      description: "Адаптивний дизайн"
    }
  },

  info: {
    title: "Unity Quest Хроніки Миру",
    subtitle: "Інтерактивне вивчення Писань",
    yourStats: "Ваша Статистика",
    score: "Рахунок",
    wisdom: "Мудрість",
    revelation: "Одкровення",
    createdWith: "Створено з ❤️",
    creator: "Emmanuel Payet",
    developerPassionate: "Розробник, захоплений духовністю",
    artistModule: "Emmanuel Художник",
    artistPortfolio: "Художнє портфоліо та цифрові творіння",
    features: "Особливості",
    multipleChapters: "91 рівень, розподілений на 8 біблійних розділів",
    powerCards: "3 унікальні карти сили (Віра, Сміливість, Мудрість)",
    progressionSystem: "Система прогресу з духовними рангами",
    bibleTreasures: "Біблійні скарби та цікаві факти",
    howToPlay: "Як Грати",
    selectLevel: "Виберіть розблокований рівень",
    choosePowerCard: "Виберіть свою карту сили",
    answerQuestions: "Відповідайте на 3 питання знання",
    earnStars: "Заробляйте зірки залежно від залишених життів",
    tips: "Поради",
    readCarefully: "Уважно читайте кожне питання",
    useWisdomCard: "Використовуйте карту Мудрості для підказок",
    courageGivesSecondChance: "Карта Сміливості дає вам другий шанс",
    faithMaximizes: "Карта Віри максимізує ваші бали",
    johnGospelTitle: "Євангеліє від Івана",
    johnGospelStats: "21 розділ • 878 віршів • 14 мов",
    bibleReaderStrong: "Читалка Біблії + Strong",
    bibleReaderStrongDesc: "Повне читання зі словником Strong",
    johnTreasures: "Скарби Івана",
    johnTreasuresDesc: "Біблійні скарби та цікаві факти",
    quickAccessChapters: "Швидкий доступ до відомих розділів:",
    johnChapter1: "Пролог",
    johnChapter3: "Народження знову",
    johnChapter14: "Я є шлях",
    johnChapter20: "Воскресіння",
    version: "Версія",
    madeWithLove: "Зроблено з любов'ю на славу Божу",
    backToMenu: "Повернутися до Меню"
  },

  bible: {
    readerTitle: "📖 Читалка Біблії",
    johnReaderTitle: "Читалка Біблії - Євангеліє від Івана",
    john: "Іван",
    loading: "Завантаження Писань...",
    loadingChapter: "Розділ {chapter} Євангелія від Івана. Повні дані завантажуються...",
    exploreWhileLoading: "Тим часом ви можете досліджувати інші розділи або використовувати функцію пошуку.",
    menu: "Меню",
    tabBible: "Біблія",
    tabUnity: "Єдність",
    strong: "Strong",
    strongReferences: "Посилання Strong",
    verses: "віршів",
    previous: "Попередній",
    next: "Наступний",
    strongDefinition: "Посилання Strong",
    word: "Оригінальне слово",
    transliteration: "Транслітерація",
    close: "Закрити",
    share: "Поділитися",
    shareVerse: "Поділитися цим віршем",
    shareSelection: "Поділитися вибраним",
    pronunciation: "Вимова",
    meaning: "Значення",
    definition: "Повне визначення",
    usage: "Біблійне використання",
    etymology: "Етимологія",
    search: "Пошук...",
    definitionNotFound: "Визначення не знайдено",
    definitionLoading: "Визначення завантажується...",
    imageFeatureComing: "🖼️ Функція зображень незабаром!",
    copyError: "Помилка при копіюванні:",
    error: "❌ Помилка",
    errorLoading: "Помилка завантаження",
    retry: "Спробувати знову",
    readerInDevelopment: "Читалка Біблії Івана в розробці...",
    verseCopied: "Вірш скопійовано в буфер обміну!",
    moreReferences: "і {{count}} інших посилань",
    copyright: "📖 LSG 1910 • Strong включено",
    markAsRead: "Уривок прочитано",
    alreadyRead: "Вже прочитано",
    readingBonus: "Бонус за читання",
    results: "результатів",
    result: "результат",
    copy: "Копіювати",
    image: "Зображення"
  },

  mountain: {
    chapter: "Розділ",
    chapterProgress: "Розділ {{current}}/{{total}}",
    secret: "Секрет!",
    spiritualAscension: "Духовне Сходження",
    levelProgress: "Рівень {{level}} • {{stars}} зірок отримано",
    combo: "Комбо",
    perfectMessage: '"Бо думки Мої - не думки ваші" - Агнець піднімається до досконалої мудрості',
    goodMessage: '"Шукайте, і знайдете" - Сходження продовжується до істини',
    startMessage: '"Віра, навіть мала як гірчичне зерно" - Перший крок до світла',
    skipAnimation: "Пропустити анімацію",
    stats: {
      points: "бал",
      level: "Рів."
    },
    waypoints: {
      start: "Старт",
      firstSlope: "Перший схил",
      lastSlope: "Останній схил"
    },
    status: {
      victory: "Перемога!",
      defeat: "Поразка",
      inProgress: "В процесі"
    }
  },

  bibleResources: {
    inAppReader: {
      name: "Читати в Додатку",
      description: "Вбудована читалка Біблії зі Strong",
      features: {
        offline: "Офлайн",
        strong: "Номери Strong",
        navigation: "Навігація"
      }
    }
  },

  quotes: {
    wisdom: "Істинне знання веде до вічної мудрості",
    faith: "Все можу в Тому, Хто зміцнює мене",
    hope: "Господь - пастир мій, не буду нужденним",
    love: "Бо так полюбив Бог світ...",
    perseverance: "Віра потребує наполегливості",
    defeat: "Невдача запрошує рости в знанні"
  },

  philosophy: {
    title: "Філософський вимір",
    loveOntology: "Любов як онтологічний принцип",
    loveDescription: "Ісус перетворює любов на метафізичний фундамент: любити Бога і ближнього стає самою структурою справжнього буття. Любов виходить за межі моралі, стаючи способом існування.",
    newCommandment: "Нова Заповідь",
    jesusEmphasizes: "Коли Ісус дає нову заповідь, він підкреслює дієслово любити",
    loveGod: "Люби Бога всім серцем твоїм",
    loveNeighbor: "Люби ближнього свого як самого себе",
    lovePriority: "Любов стає пріоритетом"
  },

  unity: unityTranslations,

  footer: {
    version: "Версія 1.0 • 2024",
    dedication: "Розроблено на славу Божу"
  },

  endCredits: {
    lines: [
      { text: "Ти досяг вершини гори", delay: 2000 },
      { text: "Ти дізнався багато нового", delay: 2000 },
      { text: "Твоя віра росте кожного дня", delay: 2000 },
      { text: "Ти переживаєш прекрасне з Богом", delay: 2000 },
      { text: "Труднощі допомагають тобі рости", delay: 2000 },
      { text: "Вони показують, що важливо", delay: 2000 },
      { text: "Будь смиренним як дитина", delay: 2000 },
      { text: "Бог любить твоє просте серце", delay: 2000 },
      { text: "У тиші ти чуєш Бога", delay: 2000 },
      { text: "Піст звільняє твій дух", delay: 2000 },
      { text: "Молися, і Бог направить тебе", delay: 2000 },
      { text: "Гординя приховує істину", delay: 2000 },
      { text: "Благодать Бога чудова", delay: 2000 },
      { text: "Вона походить з серця Бога", delay: 2000 },
      { text: "Справжня віра робить тебе вільним", delay: 2000 },
      { text: "Вона з'єднує тебе з Богом навіки", delay: 2000 },
      { text: "Любов може все змінити", delay: 2000 },
      { text: "Вона може творити чудеса", delay: 2000 },
      { text: "Повтори за мною", delay: 2000 },
      { text: "Ісусе, я віддаю Тобі своє серце", delay: 3000 },
      { text: "Ти мій цар, мій спаситель", delay: 3000 },
      { text: "Прийди і перетвори моє життя", delay: 3000 },
      { text: "Шлях продовжується тепер", delay: 2000 },
      { text: "Поділися цим прекрасним світлом", delay: 2000 },
      { text: "До життя, яке ніколи не закінчується", delay: 2000 },
      { text: "Збережи любов у своєму серці", delay: 3000 },
      { text: "Як дорогоцінний скарб", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "ВІТАЄМО!",
      proud: "МИ ПИШАЄМОСЯ ТОБОЮ",
      courage: "СМІЛИВІСТЬ ВІДВАЖНИЙ",
      peace: "НОСІЙ МИРУ",
      child: "ДИТЯ БОЖЕ",
      blessing: "НЕХАЙ БЛАГОСЛОВИТЬ ТЕБЕ БОГ",
      continue: "Продовжити"
    }
  },

  validation: {
    pseudoTooShort: "Псевдонім повинен містити не менше 2 символів",
    enterPseudo: "Будь ласка, введіть псевдонім"
  },

  pseudoSetup: {
    title: "Виберіть свій ігровий псевдонім",
    profileConfig: "Налаштування Профілю",
    connectedWith: "Підключено з",
    playerPseudo: "Ігровий Псевдонім",
    pseudoPlaceholder: "Ваш псевдонім...",
    pseudoRequirements: "2-20 символів • Відображається в рейтингах",
    suggestions: "Пропозиції",
    confirm: "Підтвердити Псевдонім",
    errorConfig: "Помилка при налаштуванні"
  },

  navigation: {
    back: "Назад"
  },

  console: {
    starsUnlocked: "зірок досягнуто! Розблокування розділу",
    defeatAnimation: "Поразка... І.Х. спускається"
  },

  errors: {
    progressionError: "Помилка прогресу",
    invalidProgressionData: "Недійсні дані прогресу:"
  },

  levels: {
    chaptersAndBonus: "8 розділів + бонусний рівень",
    bonusUnlocked: "🎊 БОНУСНИЙ РІВЕНЬ РОЗБЛОКОВАНО! Ти досяг духовної досконалості!",
    starsToDiscover: "273 {stars} для відкриття",
    starsPerLevel: "3 {stars} за рівень"
  },

  architecture: {
    title: "🏗️ Технічна архітектура",
    react: {
      name: "React",
      description: "Сучасний інтерфейс"
    },
    modules: {
      name: "Модулі",
      description: "Динамічне завантаження"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Локальне збереження"
    },
    tailwind: {
      name: "Tailwind",
      description: "Адаптивний дизайн"
    }
  },

  gameManager: {
    title: "Збереження гри",
    saveLocal: "Локальне збереження",
    saveCloud: "Хмара синхронізована",
    saveWaiting: "Очікування підключення",
    lastSave: "Останнє збереження:",
    never: "Ніколи",
    saving: "Збереження...",
    save: "Зберегти",
    loadProgress: "Завантажити",
    loading: "Завантаження...",
    autoSaveEnabled: "💾 Автозбереження увімкнено",
    saveError: "❌ Помилка збереження",
    gameSaved: "✅ Гру збережено!",
    gameLoaded: "📥 Гру завантажено!"
  }
};

export default uiTranslations;
